import { BaseFilterComponent } from './types';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { Checkbox } from '@lifeomic/chroma-react/components/Checkbox';
import { defineMessages, useIntl } from 'react-intl';
import { Filter } from '../../types';
import { FormBox } from '@lifeomic/chroma-react/components/FormBox';
import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';
import * as React from 'react';

const messages = defineMessages({
  silicoPredictor: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.silicoPredictor',
    defaultMessage: 'Predictor',
  },
  fathmm: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.fathmm',
    defaultMessage: 'FATHMM',
  },
  sift: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.sift',
    defaultMessage: 'SIFT',
  },
  muttaster: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.muttaster',
    defaultMessage: 'MUT Taster',
  },
  deleterious: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.deleterious',
    defaultMessage: 'Deleterious',
  },
  tolerated: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.tolerated',
    defaultMessage: 'Tolerated',
  },
  multi: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.multi',
    defaultMessage: '{value1}, {value2}',
  },
  addFilter: {
    id: 'omicsExplorer.filterResultsManager.components.individualInSilicoPredictors.addFilter',
    defaultMessage: 'Add Filter',
  },
});

type SelectOptionType = 'fathmm' | 'sift' | 'muttaster';

export const IndividualInSilicoPredictors: React.FC<BaseFilterComponent> = ({
  onFilterAdd,
  origin,
}) => {
  const { formatMessage } = useIntl();

  const [selectedOption, setSelectedOption] =
    React.useState<SelectOptionType>('fathmm');

  const [isDChecked, setIsDChecked] = React.useState<boolean>(false);
  const [isTChecked, setIsTChecked] = React.useState<boolean>(false);

  const handleAddFilter = () => {
    const option: Filter = {
      friendlyName: formatMessage(messages.multi, {
        value1: formatMessage(messages[selectedOption]),
        value2:
          isDChecked && isTChecked
            ? formatMessage(messages.multi, {
                value1: formatMessage(messages.deleterious),
                value2: formatMessage(messages.tolerated),
              })
            : isDChecked && !isTChecked
            ? formatMessage(messages.deleterious)
            : !isDChecked && isTChecked
            ? formatMessage(messages.tolerated)
            : null,
      }),
      id: `omicsExplorer.filters.individualInSilicoPredictors.${selectedOption}`,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      origin,
      searchKey:
        selectedOption === 'fathmm'
          ? 'dbnsfpFathmmPred'
          : selectedOption === 'sift'
          ? 'dbnsfpSiftPred'
          : 'dbnsfpMutationtasterPred',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      searchValue:
        isDChecked && isTChecked
          ? 'D,T'
          : isDChecked && !isTChecked
          ? 'D'
          : !isDChecked && isTChecked
          ? 'T'
          : null,
    };

    onFilterAdd?.(option);

    setIsDChecked(false);
    setIsTChecked(false);
  };

  return (
    <FormBox>
      <Select
        label={formatMessage(messages.silicoPredictor)}
        value={selectedOption}
        onChange={opt => {
          setSelectedOption(opt as SelectOptionType);
          setIsDChecked(false);
          setIsTChecked(false);
        }}
        fullWidth
      >
        <SelectOption title={formatMessage(messages.fathmm)} value="fathmm" />
        <SelectOption title={formatMessage(messages.sift)} value="sift" />
        <SelectOption
          title={formatMessage(messages.muttaster)}
          value="muttaster"
        />
      </Select>
      <Checkbox
        label={formatMessage(messages.deleterious)}
        checked={isDChecked}
        onChange={e => setIsDChecked(e.target.checked)}
      />
      <Checkbox
        label={formatMessage(messages.tolerated)}
        checked={isTChecked}
        onChange={e => setIsTChecked(e.target.checked)}
      />
      <Button
        onClick={handleAddFilter}
        disabled={!isTChecked && !isDChecked}
        fullWidth
      >
        {formatMessage(messages.addFilter)}
      </Button>
    </FormBox>
  );
};
